<template>
  <div class="blh-top-nav-out">
    <div class="blh-top-nav" :style="{ position: fixed ? 'fixed' : 'unset' }">
      <van-icon name="arrow-left" @click="goBack" v-if="!leftHidden"></van-icon>
      <span class="hidden-box" v-else></span>
      <span class="title van-ellipsis">{{ title }}</span>
      <slot v-if="!rightHidden">
        <span></span>
      </slot>
      <span v-else class="hidden-box">
        <van-icon name="ellipsis" class="right-icon" @click="menu = !menu" />

        <div class="menu" v-if="menu">
          <router-link to="/" tag="div" class="menu-item">
            <img src="./../assets/img/1-1.svg" alt="" />首页
          </router-link>
          <router-link to="/goodstype" tag="div" class="menu-item">
            <img src="./../assets/img/2-1.svg" alt="" />分类
          </router-link>
          <router-link to="/user/cart" tag="div" class="menu-item">
            <img src="./../assets/img/3-1.svg" alt="" />{{$common.cardName().name}}
          </router-link>
          <router-link to="/user" tag="div" class="menu-item">
            <img src="./../assets/img/4-1.svg" alt="" />我的
          </router-link>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
/**
 * 顶部导航
 */
export default {
  name: "CtopNav",
  props: {
    title: { default: "", type: String },
    leftEvent: { default: false },
    leftHidden: { default: false },
    fixed: { default: true },
    rightHidden: { default: true },
    leftShow: { default: false }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    goBack() {
      if (this.leftEvent) {
        return this.$emit("backClick");
      }
      if (!this.leftShow) {
        this.$router.go(-1);
      } else {
        this.$emit("setShow", false);
      }
    }
  }
};
</script>

<style scoped lang="less">
.blh-top-nav-out {
  height: 0.96rem;
  border-bottom: 0.02rem solid #f8f8f8;
  .blh-top-nav {
    background-color: #fff;
    width: 100vw;
    box-sizing: border-box;
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    height: 0.96rem;
    line-height: 0.96rem;
    color: #000000;
    justify-content: space-between;
    padding: 0 0.32rem;
    .title {
      font-size: 0.3rem;
      font-weight: 500;
      display: inline-block;
      max-width: 4rem;
      color: #000;
    }

    .middle-box {
      display: flex;
    }
    .van-icon {
      line-height: 0.96rem;
      font-size: 0.36rem;
    }
    .iconfont {
      font-size: 0.36rem;
      margin-right: 0.3rem;
    }
    .van-icon-arrow-left {
      color: #444444;
    }
    .van-icon-ellipsis {
      color: #2c2c2c;
    }
    .hidden-box {
      width: 0.36rem;
    }

    .right-icon {
      font-weight: bold;
      font-size: 0.4rem;
    }

    .menu {
      position: absolute;
      right: 0.1rem;
      top: 1rem;
      width: 3.2rem;
      height: 4.44rem;
      background: #ffffff;
      // box-shadow: 0rem 0.08rem 0.26rem 0rem rgba(38, 38, 38, 0.2);
      filter: drop-shadow(0 0.02rem 0.26rem rgba(38, 38, 38, 0.2));
      border-radius: 0.12rem;
      box-sizing: border-box;
      padding: 0.25rem 0 0.25rem 0.4rem;

      &::before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-width: 0.2rem 0.2rem 0.35rem 0.2rem;
        border-color: transparent transparent rgba(255, 255, 255, 1) transparent;
        border-style: solid;
        position: absolute;
        top: -0.4rem;
        right: 0.2rem;
        z-index: 99999999;
      }

      .menu-item {
        width: 2.8rem;
        border-bottom: 0.04rem solid #f5f5f5;
        display: flex;
        align-items: center;

        img {
          width: 0.52rem;
          height: 0.52rem;
          margin-right: 0.3rem;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/globTopNav.vue